import { render } from "./CreateCandidate.vue?vue&type=template&id=42e4d348&scoped=true"
import script from "./CreateCandidate.vue?vue&type=script&lang=js"
export * from "./CreateCandidate.vue?vue&type=script&lang=js"

import "../css/candidate.css?vue&type=style&index=0&id=42e4d348&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e4d348"]])

export default __exports__